import * as React from 'react';
import { useDragLayer, XYCoord } from 'react-dnd';

import { Layer } from './styles';
import DriveItem from '../../../containers/DriveItem';
import { ListDisplayType } from '../../../containers/DriveItemList/constants';
import { DndItemTypes } from '../../../typings/dnd';

interface DesktopDragPreviewProps {
	displayType: ListDisplayType;
}

const getItemStyles = (initialOffset: XYCoord | null, currentOffset: XYCoord | null) => {
	if (!initialOffset || !currentOffset) {
		return {
			display: 'none',
		};
	}

	const { x, y } = currentOffset;
	const transform = `translate(${x}px, ${y}px)`;
	return {
		transform,
		WebkitTransform: transform,
		opacity: 0.75,
	};
};

const DesktopDragPreview = ({ displayType }: DesktopDragPreviewProps) => {
	const {
		item,
		initialOffset,
		currentOffset,
		isDragging,
	} = useDragLayer(monitor => ({
		item: monitor.getItem(),
		initialOffset: monitor.getInitialSourceClientOffset(),
		currentOffset: monitor.getSourceClientOffset(),
		isDragging: monitor.isDragging(),
	}));

	if (!isDragging || item.type !== DndItemTypes.DRIVE_ITEM) {
		return null;
	}

	return (
		<Layer>
			<div style={getItemStyles(initialOffset, currentOffset)}>
				<DriveItem
					driveItem={item.driveItem}
					showUnreadBadge={false}
					displayType={displayType}
					hasActions={false}
					isDragPreview={true}
				/>
			</div>
		</Layer>
	);
};

export default DesktopDragPreview;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/DesktopDragPreview/index.tsx